"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useScrollToSingleSelect = function (listRefs, selectedIndex) {
    react_1.useEffect(function () {
        if (typeof selectedIndex === 'number') {
            var itemRefNow = listRefs.current[selectedIndex];
            if (itemRefNow && itemRefNow.current) {
                itemRefNow.current.scrollIntoView({
                    block: 'nearest',
                    behavior: 'smooth',
                });
            }
        }
    }, [selectedIndex]);
    return {};
};
exports.default = useScrollToSingleSelect;
